var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeolocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31.999,
    viewBox: "0 0 24 31.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #a6192e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-pin-svgrepo-com_3_",
    "data-name": "location-pin-svgrepo-com (3)",
    className: "cls-1",
    d: "M16.114-.011A12.326,12.326,0,0,0,4,12.193c0,6.93,6.439,14.017,10.77,19a2.446,2.446,0,0,0,1.579.8h.076a2.428,2.428,0,0,0,1.575-.8c4.064-4.672,10-12.377,10-19S23.667-.011,16.114-.011Zm.4,29.86a1.212,1.212,0,0,1-.131.107,1.218,1.218,0,0,1-.133-.107l-.523-.6C11.622,24.537,6,18.086,6,12.192a10.3,10.3,0,0,1,10.114-10.2c6.829,0,9.886,5.125,9.886,10.2,0,4.474-3.192,10.416-9.485,17.657Zm-.48-23.805a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm0,10A4.081,4.081,0,0,1,11.989,12a4,4,0,1,1,4.046,4.044Z",
    transform: "translate(-4 0.011)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocation);
export default __webpack_public_path__ + "static/media/geolocation.228fe78d180dd2ebf69bd22dc2ac85ef.svg";
export { ForwardRef as ReactComponent };